
import type { RouteRecordRaw } from 'vue-router';
import LoginAxleCallback from '@/views/LoginAxleCallback.vue';

const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'LoginIndex',
    redirect: { name: 'NotFound' },
    children: [
      {
        path: 'axle',
        name: 'LoginAxle',
        component: LoginAxleCallback,
        meta: {
          layout: 'LayoutDefault',
          requiresAuth: false,
        },
      },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/not-found',
  },
];
export default routes;
